<template>
  <loader :is-loading="loading" :fullPage="true" color="primary">
    <driver-state
      :driverStates="driverStates"
      :statusesFiltering="true"
     />
  </loader>
</template>

<script>
import { listDriverStates } from '../mixins/driverStates.mixins';

export default {
  name: 'show-fleet',
  mixins: [
    listDriverStates,
  ],
  data() {
    return {
      driverStates: [],
      interval: null,
      loading: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await this.listDriverStates();
      this.interval = setInterval(
        () => this.listDriverStates(),
        10000,
      );
    },
    destroyed() {
      clearInterval(this.interval);
    },
  },
};
</script>
